import { render } from "./DoctorWorkflow.vue?vue&type=template&id=902f9e56&ts=true"
import script from "./DoctorWorkflow.vue?vue&type=script&lang=ts"
export * from "./DoctorWorkflow.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__